'use es6';

import styled from 'styled-components';
import UITag from 'UIComponents/tag/UITag';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { rgba } from 'UIComponents/core/Color';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const getDocAnchorId = (method, path) => `anchor-${method}-${path}`;
export const AuthTag = styled(UITag).withConfig({
  displayName: "DocsUtils__AuthTag",
  componentId: "sc-1e54kxe-0"
})(["border:none;border-radius:6px;background:", ";"], rgba(CALYPSO_DARK, 0.1));

/**
 * Renders the scopes as tags
 */
export const renderAuthTypes = (securityTypes, isNewLayout = true) => {
  const TagComponent = isNewLayout ? AuthTag : UITag;
  if (!securityTypes.length) {
    return /*#__PURE__*/_jsx(TagComponent, {
      use: "calypso",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.authTypes.NO_AUTH"
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: securityTypes.map(securityType => /*#__PURE__*/_jsx(TagComponent, {
      use: "calypso",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `developer-docs-shared-components.authTypes.${securityType}`
      })
    }, securityType))
  });
};